import React from 'react';
import * as classNames from 'classnames';
import { RichUtils } from 'draft-js';

export function InlineStyleButton({ store, theme, env, inlineStyle, children }) {

	const isActived = () => {
		const editorState = store.getEditorState();
		try {
			return editorState.getCurrentInlineStyle().contains(inlineStyle);
		} catch (err) {
			return false;
		}
	};

	const toggle = () => {
		store.setEditorState(RichUtils.toggleInlineStyle(store.getEditorState(), inlineStyle));
	};

	const editorState = store.getEditorState();
	const disabled = RichUtils.getCurrentBlockType(editorState) === 'code-block';

	const className = classNames(theme.button, {
		[theme.disabled]: disabled,
		[theme.actived]: !disabled && isActived(),
	});

	return (
		<div className={theme.buttonWrapper}>
			<button className={className} onClick={disabled ? null : toggle}>
				{ children }
			</button>
		</div>
	);
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/inlineStylePlugin/InlineStyleButton.jsx